import React from 'react';
import { Box, TextButton, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { urls } from '../../../../Navigation/urls';
import { WIX_VIBE_DOMAINS_ARTICLE_ID } from './supportArticleIds';
export const ExternalViewerSubdomainNotAllowed = _ref => {
  let domainName = _ref.domainName,
    datahook = _ref.datahook;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans,
    locale = _DomainSearchSuiteMod.locale;
  const learnMoreUrl = urls.supportArticle({
    id: WIX_VIBE_DOMAINS_ARTICLE_ID,
    locale,
    referralAdditionalInfo: 'sub-domain error message'
  });
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    marginTop: "SP4",
    textAlign: "center",
    dataHook: datahook
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.wix_vibe.subdomain",
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "normal",
      as: "a",
      target: "_blank",
      href: learnMoreUrl,
      onClick: () => {
        DomainSearchSuiteModule.internals.bi.onClickLink == null || DomainSearchSuiteModule.internals.bi.onClickLink({
          link: learnMoreUrl,
          domain: domainName
        });
      }
    })]
  })));
};
//# sourceMappingURL=ExternalViewerSubdomainNotAllowed.js.map